import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import Login from "./authentication/login";

// Alleen nog de loginpagina: inloggen gaat met een e-mailcode via de API.
// Wachtwoord-vergeten en uitnodiging-accepteren bestaan niet meer; een oude
// uitnodigingslink komt via de catch-all op de loginpagina uit.
export const AuthViews = () => {
  return (
    <Suspense fallback={<Loading cover="page" />}>
      <Routes>
        <Route path={"/login"} element={<Login />} />
        <Route path={`*`} element={<Navigate to={"/auth/login"} replace />} />
      </Routes>
    </Suspense>
  );
};

export default AuthViews;
